import { APIConfig } from './API.config';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TokenService } from '../auth/token.service';
interface IAPIBase {
  getPath(resource: string): string;
  getDefaultHeaders(): { [headerName: string]: string };
  authorizationHeader(): Promise<Record<string, string>>;
}

interface RequestOptions {
  headers?: HttpHeaders | { [header: string]: string | string[] };
  params?: HttpParams | { [param: string]: string | string[] };
}

@Injectable({
  providedIn: 'root'
})
export class APIBase implements IAPIBase {
  apiConfig: APIConfig;

  constructor(
    private http: HttpClient,
    private tokenService: TokenService
  ) {
    this.apiConfig = {
      SERVER_PATH: environment.apiBaseUrl,
      headers: {},
    };
  }

  getPath(resource: string): string {
    return this.apiConfig.SERVER_PATH + resource;
  }

  getDefaultHeaders(): {[headerName: string]: string} {
    return this.apiConfig.headers;
  }

  getOptions(options?: RequestOptions): RequestOptions {
    return {
      ...options || {},
      headers: {
        ...options?.headers,
        ...this.getDefaultHeaders()
      }
    };
  }

  // TODO: Move to APIAuthFlow service When we get another Auth Provider
  async bearerToken(): Promise<string> {
    return (await this.tokenService.currentAuthenticatedUser()).token;
  }

  // TODO: Move to APIAuthFlow service When we get another Auth Provider
  async authorizationHeader(): Promise<Record<string, string>> {
    const token: string = await this.bearerToken();
    return {
        Authorization: `Bearer ${token}`,
    };
  }

  /* istanbul ignore next */
  get<T>(url: string, options?: RequestOptions): Observable<T> {
    return this.http.get<T>(this.getPath(url), this.getOptions(options));
  }

  /* istanbul ignore next */
  post<T>(url: string, body: any, options?: RequestOptions): Observable<T> {
    return this.http.post<T>(this.getPath(url), body, this.getOptions(options));
  }

  /* istanbul ignore next */
  put<T>(url: string, body: any, options?: RequestOptions): Observable<T> {
    return this.http.put<T>(this.getPath(url), body, this.getOptions(options));
  }

  /* istanbul ignore next */
  delete<T>(url: string, options?: RequestOptions): Observable<T> {
    return this.http.delete<T>(this.getPath(url), this.getOptions(options));
  }
}
